var map = {
	"./4skills-icon.svg": 2043,
	"./4skills-tile.svg": 5460,
	"./account--icon.svg": 5041,
	"./already-submitted.svg": 6697,
	"./arrow-right-blue--icon.svg": 2581,
	"./arrow-right.svg": 7095,
	"./back-photo-placeholder.svg": 5873,
	"./bulb-icon.svg": 6572,
	"./can-verify-id--icon.svg": 7966,
	"./cert-blue-shield.svg": 9172,
	"./cert-purple-shield.svg": 262,
	"./certificate-copy-icon.svg": 920,
	"./clock.svg": 371,
	"./computer-requirements--icon.svg": 1772,
	"./copy-icon.svg": 8226,
	"./dancing-people.svg": 8187,
	"./dashboard--account__passwordChanged.svg": 4843,
	"./dashboard--icon.svg": 2604,
	"./exploreTests--4-skills.svg": 1842,
	"./exploreTests--reading-and-writing.svg": 748,
	"./exploreTests--speaking-and-listening.svg": 5887,
	"./exploreTests-getting-ready.svg": 7666,
	"./featuresOfProduct--authentic.svg": 2449,
	"./featuresOfProduct--convenient.svg": 6823,
	"./featuresOfProduct--fast.svg": 3166,
	"./front-facint-camera--icon.svg": 8986,
	"./government-id--icon.svg": 1217,
	"./hamburger-menu.svg": 172,
	"./homePage--cta.png": 359,
	"./homePage--ctaFlexible.svg": 8968,
	"./homePage--cta__myTopScore.png": 3546,
	"./idv-image-blurry.png": 1455,
	"./idv-image-covered.png": 697,
	"./idv-image-valid.png": 7569,
	"./idv-image-without-corners.png": 1566,
	"./info-icon.svg": 4927,
	"./link-arrow.svg": 563,
	"./logout-mobile.svg": 8104,
	"./notFoundPage--404.svg": 8211,
	"./orderError.png": 6793,
	"./pearson-logo-mobile.png": 6804,
	"./pearson-logo-tm.png": 2443,
	"./person--icon.svg": 7157,
	"./question-sign.svg": 6079,
	"./reading-cert.svg": 1899,
	"./reading-writing-icon.svg": 384,
	"./reliable-internet--icon.svg": 2860,
	"./results--icon.svg": 2358,
	"./single-monitor--icon.svg": 4607,
	"./spare-time--icon.svg": 9467,
	"./speaker-microphone--icon.svg": 1658,
	"./speaking-cert.svg": 8884,
	"./speaking-listening-icon.svg": 3949,
	"./speaking-sample-blue.svg": 4241,
	"./take-photo-button.svg": 7873,
	"./verification--uploadId__allDone.svg": 2503,
	"./verification--uploadId__qrcodePreview.svg": 8551,
	"./verification--uploadId__sessionExpired.svg": 1181,
	"./well-it-space--icon.svg": 2559,
	"./writing-sample-yellow.svg": 8121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;